import { flow, getParent, types } from 'mobx-state-tree';
import { sellerWasConnectedOnOtherAccount } from '../../constants/connectAccountErrors';

const AzdConnection = types
  .model('azdConnection', {
    developerData: types.optional(types.frozen, {}),
    mwsAuthToken: '',
    sellerId: '',
    accountName: '',
  })
  .views(self => ({
    get settingsStore() {
      return getParent(self).settingsStore;
    },
    get transport5007() {
      return getParent(self).transport5007;
    },
    get showToast() {
      return getParent(self).toastsStore.showToast;
    },
    get enums() {
      return getParent(self).enumsStore.getEnumsList;
    },
    get accountValid() {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(self.accountName.toLowerCase());
    },
    get inputsValid() {
      return self.mwsAuthToken && self.accountValid && self.sellerId;
    },
  }))
  .actions(self => ({
    setMwsAuthToken: val => {
      self.mwsAuthToken = val;
    },
    setSellerId: val => {
      self.sellerId = val;
    },
    setAccountName: val => {
      self.accountName = val;
    },
    reinit() {
      self.mwsAuthToken = '';
      self.sellerId = '';
      self.accountName = '';
    },
    getDestinationsAndSettings: flow(function* getDestinationsAndSettings() {
      yield self.settingsStore.connectionManagement.fetchConnectedAccounts();
      yield self.settingsStore.markets.initMarkets();
      yield self.settingsStore.listing.fetchListingOptions();
    }),
    getDeveloperData: flow(function* getDeveloperData() {
      try {
        const { data } = yield self.transport5007.fetch(
          'amazon-listing-api/v1/seller-accounts/developer-id',
        );
        self.developerData = data;
      } catch (error) {
        console.error('destination fetch fail: ', error);
      }
    }),
    connectSeller: flow(function* connectSeller() {
      const { mwsAuthToken, sellerId, accountName } = self;
      const params = {
        accountName,
        sellerId,
        mwsAuthToken,
        destinationMarketplaceId: 'AZD_US',
      };
      try {
        const { data } = yield self.transport5007.post(
          'seller-account/v1/seller-accounts/amazon',
          params,
        );
        console.log(data);
        yield self.getDestinationsAndSettings();
      } catch (error) {
        if (
          error.response.data &&
          error.response.data.toString() === sellerWasConnectedOnOtherAccount
        )
          self.showToast({
            type: self.enums.TOAST_TYPES.WARNING,
            message: error.response.data,
          });
        console.error('destination fetch fail: ', error);
      }
    }),
  }));

export default AzdConnection;
